
    /**
    * 修改地址
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13205 {
  /**
   * 省份province_id
   */
  provinceCode?: string;
  /**
   * 市id
   */
  cityCode?: string;
  /**
   * 地址编号
   */
  addressNo?: string;
  /**
   * 区id
   */
  districtCode?: string;
  /**
   * 街道id
   */
  streetCode?: string;
  /**
   * 联系地址
   */
  detailAddress?: string;
  /**
   * 邮政编码
   */
  postCode?: string;
  /**
   * 收货人
   */
  receiver?: string;
  /**
   * 手机号码
   */
  phone?: string;
  /**
   * 是否默认地址:0默认1不默认
   */
  isDefault?: string;
}
  export class IResid13205 {
  code?: number;
  data?: null;
  message?: string;
  success?: boolean;
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13205, IResid13205['data'] > = (data?) =>  request({
        method: 'POST',
        url: '/expressAddress/update',
        data: data
      }) 
  export default http